import { patchState, signalStore, withMethods, withState } from '@ngrx/signals'

export type SubstitutionTags = Record<string, string>

const initialState: { substitutionTags: SubstitutionTags } = {
  substitutionTags: {},
}

export const SubstitutionTagsStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => ({
    setSubstitutionTags: (substitutionTags: any[]): void => {
      const _substitutionTags = substitutionTags.reduce(
        (acc, tag) => ({ ...acc, [tag.code]: tag.content }),
        {}
      )
      patchState(store, { substitutionTags: _substitutionTags })
    },
    getSubstitutionTagByKey: (code: string): string | undefined =>
      Object.hasOwn(store.substitutionTags(), code) ? store.substitutionTags()[code] : undefined,
    clearSubstitutionTags: (): void => {
      patchState(store, { substitutionTags: {} })
    },
  }))
)
